import { IDonViTinh } from "../../../model/respone/category/IDonViTinh"
import { generateActionTypeIds } from "../generateActionTypeIds"
import IGenericActionType from "../IGenericActionType"

export const eDonViTinhActionTypeDefine = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as IDonViTinh[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as undefined | IDonViTinh,
    CLOSE_EDIT_MODAL: undefined,
    
    SAVE_START: {} as IDonViTinh,
    SAVE_SUCCESS: {} as IDonViTinh,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",


}
export const eDonViTinhActionTypeIds = generateActionTypeIds(eDonViTinhActionTypeDefine, "DON_VI_TINH")

export type IDonViTinhActions = IGenericActionType<typeof eDonViTinhActionTypeDefine, "DON_VI_TINH">